import { formatName } from "~/utils/namingUtils"

export const TableColumnGroups = {
  ProductInformation: "Product Information",
  AvailabilityAndInventory: "Availability & Inventory",
  SalesAndForecast: `${formatName("sale", true, true)} & Demand`,
  SalesPerformance: "Sales Performance",
  OperationalMetrics: "Operational Metrics",
  Collections: "Collections",
  ModelsAndAnalysis: "Models & Analysis",
  ExternalData: "External Data",
  ExternalCollectionData: "External Collection Data",
  DemandMetrics: "Demand Metrics",
  TrimMetrics: "Trim Metrics",
  SupplyPlanning: "Supply Planning",
  ForecastMetrics: "Demand Insights",
  NewProductIntroduction: "New Product Introduction",
  AllocationInfo: "Allocation Info",
  Suggestion: "Suggestion",
  ProductSettings: "Product settings",
  Value: "Value",
  // Purchase-order specific groups (also re-exported via POColumnGroups)
  OrderQuantities: "Order Quantities",
  MOQAndConstraints: "MOQ and Constraints",
  Actions: "Actions",
  Other: "Other",
} as const
export type TableColumnGroups = (typeof TableColumnGroups)[keyof typeof TableColumnGroups]
